import { clsx, type ClassValue } from 'clsx'
import { twMerge } from 'tailwind-merge'

/**
 * Junta classes do Tailwind resolvendo conflito pela última.
 *
 * Sem isto, `className` vindo de fora de um componente não consegue sobrescrever o
 * padrão dele — as duas classes ficam na string e quem vence é a ordem do CSS, que
 * ninguém controla. É também o motivo de não haver `style={{}}` em lugar nenhum.
 */
export function cn(...classes: ClassValue[]): string {
  return twMerge(clsx(classes))
}
